import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './finance-calculator-item.component.scss';
var FinanceCalculatorItem = /** @class */ (function (_super) {
    tslib_1.__extends(FinanceCalculatorItem, _super);
    function FinanceCalculatorItem(element) {
        return _super.call(this, element) || this;
    }
    FinanceCalculatorItem.prototype.init = function () { };
    FinanceCalculatorItem.prototype.bindEvents = function () { };
    return FinanceCalculatorItem;
}(Base));
export { FinanceCalculatorItem };



//////////////////
// WEBPACK FOOTER
// ./components/finance-calculator-item/finance-calculator-item.component.ts
// module id = 1073
// module chunks = 0